function usePrice() {
    const rate = 1.0;
    const sign = '$';

    const priceFormat = price => {
        const options = {style: 'currency', currency: 'USD'};
        return sign + '' + parseFloat(price).toLocaleString('en-US', options).replace('$', '');
    }

    const priceConvert = price => {
        return parseFloat(price) * rate;
    }

    return {
        priceFormat: priceFormat,
        priceConvert: priceConvert,
    }
}

export default usePrice;
